module.exports = __webpack_public_path__ + "media/images/not_found-c8301e2ab508b7ed9a3396b80adca305.svg";